import { createReducer, isAnyOf } from '@reduxjs/toolkit';

import { fetchEntitySuccess } from 'modules/entity/actions';
import { fetchTemplateSuccess } from 'modules/entity/subEntities/customize/actions';
import { FETCH_ENTITY_FAILURE } from 'modules/entity/actionTypes';
import { postUnsubscribeSuccess } from 'modules/customers/actions';
import * as customersActionTypes from 'modules/customers/actionTypes';

import { fetchTranslationsSuccess } from '../actions';

/**
 * @typedef {{[key: string]: string}} TranslationsState
 */

/** @type {TranslationsState} */
const initialState = {};

/**
 * @param {TranslationsState} _
 * @param {{payload: {translations: TranslationsState}}} action
 * @returns {TranslationsState}
 */
const set = (_, { payload }) => payload.translations;

/**
 * @param {TranslationsState} _
 * @param {{payload: import('axios').AxiosError<{data: {translations: TranslationsState}}}} action
 * @returns {TranslationsState}
 */
const setFromFailure = (_, { payload }) => payload.response?.data?.data?.translations;

/**
 * @param {{[key: string]: string} | string} state
 * @param {import('modules/customers/types').PostUnsubscribeFailureAction} action
 * @returns {{[key: string]: string}}
 */
const setOnError = (state, { payload: error }) => (typeof error === 'object' ? error.translations : state);

export default createReducer(initialState, (builder) => {
  builder
    .addCase(FETCH_ENTITY_FAILURE, setFromFailure)
    .addCase(customersActionTypes.POST_CUSTOMER_LEADS_UNSUBSCRIBE_FAILURE, setOnError)
    .addMatcher(
      isAnyOf(
        fetchEntitySuccess.match,
        fetchTranslationsSuccess.match,
        fetchTemplateSuccess.match,
        postUnsubscribeSuccess.match
      ),
      set
    );
});
